import * as Accordion from '@radix-ui/react-accordion';
import styled, { keyframes } from 'styled-components';
import { buttoBaseStyle } from '@screens/lp-default/styles';

export const slideDown = keyframes`
    from {
    height: 0;
  }
    to {
    height: 150px;
  }
`;

export const slideUp = keyframes`
    from {
    height: 150px;
  }
    to {
    height: 0;
  }
`;

export const AccordionItem = styled(Accordion.Item)`
  & > button {
    background: none;
    border: none;
    display: flex;
    margin: 12px 0;
    padding: 0;
    width: 100%;
  }

  &[data-state='closed'] {
    h5 {
      color: ${({ theme }) => theme.elsie.colors.content.soft};
    }
  }

  &[data-state='open'] {
    h5 {
      color: ${({ theme }) => theme.elsie.colors.content.subtle};
    }
  }
`;

export const AccordionTrigger = styled(Accordion.Trigger)`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  &[data-state='open'] svg {
    transform: rotate(180deg);
  }
`;

export const AccordionTitle = styled.h5`
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-size: ${({ theme }) => theme.elsie.fontSize.sm};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: 0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0;
  text-align: left;
`;

export const AccordionButton = styled.span`
  ${buttoBaseStyle};
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  background-color: rgba(0, 0, 0, 0.04);
  padding: ${({ theme }) => theme.elsie.dimension[6]};
`;

export const AccordionContent = styled(Accordion.Content)`
  &[data-state='open'] {
    animation: ${slideDown} 200ms cubic-bezier(0.87, 0, 0.13, 1);
  }
  &[data-state='closed'] {
    animation: ${slideUp} 200ms cubic-bezier(0.87, 0, 0.13, 1);
  }
  overflow: hidden;
  position: relative;
`;

export const TabSubtitle = styled.p`
  color: ${({ theme }) => theme.elsie.colors.content.soft};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin-top: 4px;
`;

export const DetailsWrapper = styled.section`
  display: flex;
  gap: 12px;
`;

export const ToolTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 80%;
`;
